import React, { useState } from 'react';
import { TOS_TEXT, PP_TEXT, renderLegalBody } from './Taskbar';
import '../css/taskbar.css';
import '../css/agreement.css';

function AgreementModal({ onAgree, onDecline }) {
  const [checked, setChecked] = useState(false);
  const [showTos, setShowTos] = useState(false);
  const [showPp, setShowPp] = useState(false);

  return (
    <>
      <div className="agreement-overlay">
        <div className="agreement-modal">
          <div className="agreement-brand">
            <span className="agreement-brand-ganache">ganache</span>
            <span className="agreement-brand-wedding">
              wedding<sup style={{ fontSize: '0.6em', verticalAlign: 'super', lineHeight: 0 }}>™</sup>
            </span>
          </div>
          <p className="agreement-intro">
            Before you continue, please review and agree to our Terms of Service and Privacy Policy.
          </p>
          <div className="agreement-view-links">
            <button className="agreement-view-btn" onClick={() => setShowTos(true)}>
              View Terms of Service
            </button>
            <button className="agreement-view-btn" onClick={() => setShowPp(true)}>
              View Privacy Policy
            </button>
          </div>
          <label className="agreement-checkbox-label">
            <input
              type="checkbox"
              className="agreement-checkbox"
              checked={checked}
              onChange={e => setChecked(e.target.checked)}
            />
            <span>
              I have read and agree to the{' '}
              <button className="agreement-inline-link" onClick={e => { e.preventDefault(); setShowTos(true); }}>
                Terms of Service
              </button>
              {' '}and{' '}
              <button className="agreement-inline-link" onClick={e => { e.preventDefault(); setShowPp(true); }}>
                Privacy Policy
              </button>
            </span>
          </label>
          <div className="agreement-actions">
            <button className="agreement-btn agreement-btn--decline" onClick={onDecline}>
              Decline &amp; Sign Out
            </button>
            <button
              className="agreement-btn agreement-btn--continue"
              disabled={!checked}
              onClick={onAgree}
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      {showTos && (
        <div className="tos-overlay agreement-sub-overlay" onClick={() => setShowTos(false)}>
          <div className="tos-modal" onClick={e => e.stopPropagation()}>
            <div className="tos-header">
              <h2 className="tos-title">Terms of Service</h2>
              <button className="tos-close" onClick={() => setShowTos(false)}>×</button>
            </div>
            <div className="tos-body">
              {renderLegalBody(TOS_TEXT, 'agr-tos', { onOpenPP: () => { setShowTos(false); setShowPp(true); } })}
            </div>
          </div>
        </div>
      )}

      {showPp && (
        <div className="tos-overlay agreement-sub-overlay" onClick={() => setShowPp(false)}>
          <div className="tos-modal" onClick={e => e.stopPropagation()}>
            <div className="tos-header">
              <h2 className="tos-title">Privacy Policy</h2>
              <button className="tos-close" onClick={() => setShowPp(false)}>×</button>
            </div>
            <div className="tos-body">
              {renderLegalBody(PP_TEXT, 'agr-pp')}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AgreementModal;
